/* eslint-disable no-unused-vars */

import { CaptionText, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from '../Portfolio.styled';
import moment from 'moment';

import { useTranslation } from 'react-i18next';
import Spinner from '../../../components/common/Spinner';
import { activateMinara } from '../Portfolio.actions';
import { useDispatch } from 'react-redux';
import { TextWithTooltip } from '../../../components/common/TextWithTooltip';

export const MinaraItem = ({ item }: { item: any }) => {
  const { t } = useTranslation('my_hubs');

  const dispatch = useDispatch();

  return (
    <BoxBig relative>
      <HubImage image={item?.imageUrl}>
        <H4 color={color.colors.neutral0}>{item.product?.name}</H4>
      </HubImage>
      <Flexed column between>
        <Flexed>
          <div
            style={{
              position: 'absolute',
              left: '50%',
              right: '50%',
              transform: 'translate(-50%, -50%)'
            }}>
            <Spinner />
          </div>
          <Tr style={{ cursor: 'pointer' }}>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                ORDER ID
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {item?.id}
              </P1>
            </Td>

            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('date_of_purchase')}
              </CaptionText>
              <P1 bold>{moment(item?.datePaid).format('DD MMMM YYYY')}</P1>
            </Td>
          </Tr>
        </Flexed>
        <Flexed between rowSM>
          <P2 mr='5' bold color={colors.primary900} mbSM='10'>
            MINARA Credits: {item?.credits}
          </P2>

          <Flexed between gap='1'>
            <Button
              w='150px'
              h='40px'
              disabled={item?.isActive}
              color={item?.isActive ? colors.neutral700 : colors.primary900}
              onClick={() => {
                dispatch(
                  activateMinara({
                    userPackageId: item?.id
                  })
                );
              }}>
              {item?.isActive ? 'Activated' : 'Activate'}
            </Button>
            {!item?.isActive && (
              <TextWithTooltip
                disabled={false}
                mobile
                tooltip={
                  <div>
                    Once you click the activation button, your Minara account is
                    created. <br />
                    <br />
                    If the redirection does not happen automatically during
                    activation, it is likely due to local settings (either your
                    browser or PC).
                    <br />
                    <br /> In that case, simply:
                    <br />
                    <br /> 1. Go to the Minara.ai website <br />
                    <br />
                    2. At the Minara login page, enter the email connected to BO
                    (the same email used during activation)
                    <br />
                    <br /> 3. Check your email for a temporary code, which
                    serves as your password for the Minara login.
                  </div>
                }></TextWithTooltip>
            )}
          </Flexed>
        </Flexed>
      </Flexed>
    </BoxBig>
  );
};
